export enum ModalSize {
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
  FULL = 'full',
}

export enum ModalPosition {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
}

export enum ModalShape {
  SQUARE = 'square',
  ROUNDED = 'rounded',
}

export enum ModalHeight {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
  FULL = 'full',
  AUTO = 'auto',
}
